import React from 'react';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane } from 'owa-drawer';
import {
    ChatCopilotPane as LazyChatCopilotBody,
    ChatCopilotPaneHeader as LazyChatCopilotPaneHeader,
} from 'owa-copilot-chat';
import { observer } from 'owa-mobx-react';
import { isFlexPaneExpanded } from 'owa-suite-header-store';
import closeAppPane from '../../orchestration/closeAppPane';
import {
    bodyContainer,
    header,
    paneContainer,
    paneContainerExpanded,
} from './ChatCopilotPane.scss';

const chatCopilotPaneTitle = () => {
    return <LazyChatCopilotPaneHeader />;
};

export default observer(function ChatCopilotPane() {
    const paneId = getDrawerPaneId('chatCopilot');

    const handleDismiss = React.useCallback(() => {
        closeAppPane(paneId);
    }, [paneId]);

    return (
        <DrawerPane
            className={isFlexPaneExpanded(paneId) ? paneContainerExpanded : paneContainer}
            paneId={paneId}
            headerText={chatCopilotPaneTitle()}
            headerClassName={header}
            bodyClassName={bodyContainer}
            onDismiss={handleDismiss}
        >
            <LazyChatCopilotBody />
        </DrawerPane>
    );
}, 'ChatCopilotPane');
